import { render, staticRenderFns } from "./termListView.vue?vue&type=template&id=f5c8815c&scoped=true&"
import script from "./termListView.vue?vue&type=script&lang=js&"
export * from "./termListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c8815c",
  null
  
)

export default component.exports